import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Table from '../../elements-table/table';
import { itemCategory } from './PayoutsUtils';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

const PendingPayoutItems = ({ payout, intl }) => {
  const category = get(itemCategory, [payout.category], {});
  const firstName = get(payout, 'guest.name.first', '');
  const lastName = get(payout, 'guest.name.last', '');
  const useType = get(payout, 'listing.use_type', '');
  const bookingId = get(payout, 'booking.id', '');
  const isHostReferral = 'referral_commission' === payout.category;
  const itemLabel = (<FormattedMessage id="hosting.pending_payout_items.label" defaultMessage="{category} for {firstName} {lastName}'s {useType}" values={{ category: intl.formatMessage(category.text), firstName: firstName, lastName: lastName, useType: useType.toLowerCase().replace('-', '') }}/>);

  return (
    <div className="payouts-items-table">
      <Table
        headerContainerClass="payouts-items-table-header"
        tableHeaders={
          [
            { label: <FormattedMessage id="hosting.pending_payout_items.table_header_item" defaultMessage="Item"/>, classname: 'flex-basis-35-sm flex-basis-45' }
          ]
        }
        tableBodyClass="payouts-table-body no-gutter"
        tableBody={
          <div className="flex payout-items-row">
            <div className="flex-basis-95 ellipsis flex middle">
              <img alt={intl.formatMessage(category.alt)} className="margin-md-right ico" src={`/web-hosting/assets/images/${category.icon}.svg?v=rb`} />
              { isHostReferral ? <span>{ itemLabel }</span> : <a className="underline" href={`/inbox/${bookingId}`}>{ itemLabel }</a> }
            </div>
          </div>
        }
      />
    </div>
  );
};

PendingPayoutItems.propTypes = {
  payout: PropTypes.object.isRequired,
  intl: intlShape
};

export default injectIntl(PendingPayoutItems);
